export default "__VITE_ASSET__8bd4388f__"